import { isEmpty } from 'ramda';
import { useSelector } from 'react-redux';
import { businessTariffsPromoQuotaMobile } from 'reactApp/appHelpers/featuresHelpers/features/businessTariffsPromoQuotaMobile';
import {
    familyByOptionsFeatureMobile,
    multiTariffTouchRegularOrAnonymous,
    multiTariffWebview,
} from 'reactApp/appHelpers/featuresHelpers/features/multiTariffMobile';
import {
    isPriceDifferentiation,
    priceDiffBusinessTariffListMobile,
} from 'reactApp/appHelpers/featuresHelpers/features/priceDifferentiation';
import { BillingPersonalizationSelectors } from 'reactApp/modules/billingPersonalization/billingPersonalization.selectors';
import { skipBillingPersonalization } from 'reactApp/sections/QuotaLanding/billingPersonalizationQuotaLandingSegment';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';

const getTabOptions = () => {
    const options: Array<{ value: ETabsName; text: string }> = [];

    if (multiTariffTouchRegularOrAnonymous === 'b' || multiTariffWebview === 'c') {
        options.push({
            value: ETabsName.basic,
            text: 'Минимальный',
        });
    }

    options.push({
        value: ETabsName.advanced,
        text: 'Основной',
    });

    if ((priceDiffBusinessTariffListMobile && isPriceDifferentiation) || businessTariffsPromoQuotaMobile.enabled) {
        options.push({
            value: ETabsName.for_work,
            text: 'Для работы',
        });
    }

    if (!familyByOptionsFeatureMobile) {
        options.push({
            value: ETabsName.family,
            text: 'Семейный',
        });
    }

    return options;
};
const tabOptions = getTabOptions();

export const useTabOptions = () => {
    const personalizationTariffs = useSelector(BillingPersonalizationSelectors.getTariffIDsMobile);
    const isBillingPersonalisationEnabled = useSelector(BillingPersonalizationSelectors.isBillingPersonalisationEnabledMobile);
    const skipPersonalization = skipBillingPersonalization();

    if (isBillingPersonalisationEnabled && !skipPersonalization) {
        return tabOptions.filter((tab) => Boolean(personalizationTariffs[tab.value]) && !isEmpty(personalizationTariffs[tab.value]));
    }

    return tabOptions;
};
